import { Map } from 'immutable'
import isArray from 'lodash/isArray'

export {
  dataFetched,
  dataFetchedReducerFactory,
  GRAPHQL_DATA_FETCHED,
} from './dataFetched'
export {
  dataAdded,
  dataAddedReducerFactory,
  GRAPHQL_DATA_ADDED,
} from './dataAdded'
export {
  dataRemoved,
  dataRemovedReducerFactory,
  GRAPHQL_DATA_REMOVED,
} from './dataRemoved'

export { getEntityMap, getEntity, rehydrate } from './selectors'

function simpleObjectMerger(previousValue = Map(), newValue) {
  return previousValue.merge(newValue)
}

// REDUCER
export function makeBaseGraphQLReducer({
  subReducerFactories = {},
  entityMergers = {},
  getEntityKeyField,
  refBuilder = x => Map(x),
  defaultEntityMerger = simpleObjectMerger,
  extraAddReducer = {},
  extraRemoveReducer = {},
} = {}) {
  const subReducers = Object.keys(subReducerFactories).reduce(
    (subreducers, actionType) => {
      const factory = subReducerFactories[actionType]
      const subreducer = factory({
        entityMergers,
        refBuilder,
        getEntityKeyField,
        defaultEntityMerger,
        extraAddReducer,
        extraRemoveReducer,
      })

      return {
        ...subreducers,
        [actionType]: subreducer,
      }
    },
    {}
  )

  return function graphQLReducer(state = Map(), { type, payload, metadata }) {
    if (metadata && metadata.graphql) {
      state = graphQLReducer(state, metadata.graphql)
    }

    const reducer = subReducers[type]

    if (reducer) {
      if (isArray(payload)) {
        return payload.reduce(reducer, state)
      }
      return reducer(state, payload)
    }

    return state
  }
}
